import React from 'react';
import { motion } from 'framer-motion';
import { Loader2, Wrench, Users, CheckCircle } from 'lucide-react';

interface PageLoadingProps {
  title?: string;
  subtitle?: string;
  showProgress?: boolean;
}

const PageLoading: React.FC<PageLoadingProps> = ({ 
  title = '快修通',
  subtitle = '正在為您準備最佳體驗',
  showProgress = true 
}) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center"
      >
        {/* Logo 和標題 */}
        <motion.div
          initial={{ scale: 0.8 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2 }}
          className="mb-8"
        >
          <div className="flex items-center justify-center mb-4">
            <Wrench className="w-12 h-12 text-blue-600 mr-3" />
            <h1 className="text-3xl font-bold text-gray-900">{title}</h1>
          </div>
          <p className="text-gray-600">{subtitle}</p>
        </motion.div>

        {/* 加載動畫 */}
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
          className="mb-8"
        >
          <Loader2 className="w-12 h-12 text-blue-600 mx-auto" />
        </motion.div>

        {/* 功能圖標 */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
          className="flex justify-center space-x-8 mb-8"
        >
          <div className="flex flex-col items-center">
            <Users className="w-8 h-8 text-green-600 mb-2" />
            <span className="text-xs text-gray-600">專業工匠</span>
          </div>
          <div className="flex flex-col items-center">
            <CheckCircle className="w-8 h-8 text-blue-600 mb-2" />
            <span className="text-xs text-gray-600">品質保證</span>
          </div>
          <div className="flex flex-col items-center">
            <Wrench className="w-8 h-8 text-purple-600 mb-2" />
            <span className="text-xs text-gray-600">即時服務</span>
          </div>
        </motion.div>

        {/* 進度條 */}
        {showProgress && (
          <motion.div
            initial={{ width: 0 }}
            animate={{ width: "100%" }}
            transition={{ duration: 2, ease: "easeInOut" }}
            className="w-64 h-2 bg-gray-200 rounded-full mx-auto overflow-hidden"
          >
            <motion.div
              initial={{ width: 0 }}
              animate={{ width: "100%" }}
              transition={{ duration: 2, ease: "easeInOut" }}
              className="h-full bg-gradient-to-r from-blue-500 to-purple-600 rounded-full"
            />
          </motion.div>
        )}
      </motion.div>
    </div>
  );
};

export default PageLoading;
